<template>
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <span class="close-button" @click="closeModal">&times;</span>
      <h2>請再次確認</h2>
      <p>
        確定使用
        <strong>{{ selectedOfferCard.bank }}｜{{ selectedOfferCard.name}}</strong>
        折抵停車費用嗎？ 
        <!-- <strong>{{discountHours}} 小時</strong> 嗎？ -->
      </p>
      <div class="button-group">
        <button class="cancel-button" @click="cancelDiscount">取消</button>
        <button class="apply-button" @click="confirmDiscount">確定折抵</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true,
      maxDiscountHours: 1 // Replace with the actual discount hours value as needed
    };
  },
  props: {
    discountHours: {
      type: Number,
      required: true
    },
    selectedOfferCard: {
      type: Object,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    confirmDiscount() {
      // this.$emit('updateState', { key: 'discountHours', value: this.maxDiscountHours });
      this.$emit('discount-hours-double-confirmed');
    },
    cancelDiscount() {
      this.$emit('cancel-discount');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 10px;
  margin-top: 30vh;
  width: 480px;
  padding: 24px 30px;
  position: relative;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
}

h2 {
  font-size: 20px;
  color: var(--green03);
  font-weight: bold;
  /* 加粗標題 */
  margin-top: 0;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  color: #333;
  margin: 20px auto;
}

p strong {
  font-weight: bold;
  /* 加粗台新銀行｜昇恆昌無限卡和1小時 */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.button-group {
  display: flex;
  gap: 16px;
  /* 按钮之间的间距 */
  margin-top: 20px;
}

.apply-button,
.cancel-button {
  width: 136px;
  padding: 16px;
  border-radius: 99px;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}

.apply-button {
  background-color: var(--green03);
  color: white;
  border: none;
}

h2 {
  font-size: 32px;
  color: var(--green03);
  margin-top: 0;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  width: 330px;
  color: #333;
  /* margin: 20px 0 40px; */
  margin: 20px auto;
}

.apply-button:hover {
  background-color: var(--green02);
}

.cancel-button {
  background-color: white;
  color: var(--green03);
  border: 1px solid var(--green03);
}

.cancel-button:hover {
  background-color: #f5f5f5;
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
  }

  h2 {
    font-size: 24px;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
  }

  .apply-button,
  .cancel-button {
    font-size: 14px;
    padding: 10px 20px 10px 20px;

    width: 240px;
    /* 调整小屏幕按钮宽度 */
  }

  .button-group {
    flex-direction: column;
    gap: 12px;
    /* 小屏幕时按钮间距减少 */
  }
}
</style>
